<template>
  <div class="row">
    <div class="col-lg-6">
      <div class="card p-5">
      


        <form-group label="File">
          <small>csv,xls or xlsx file</small><br>
          <small class="text-danger">Row 1 should contain column headings exactly as specified below</small>
              <file-upload
                @files-uploaded="
                  selectedFile = $event;
                  fileUploading = false;
                "
                @files-uploaded-started="fileUploading = true"
                :multiple="false"
                accepted-types=".xlsx,.csv"
              />
               
            </form-group>
           

        <b-button variant="primary" @click="handleSubmit" v-if="!loading"> Upload </b-button>
        <b-spinner label="Spinning" v-if="loading"></b-spinner>


 <h6 class="text-danger mt-5">Leave a column blank if you do not want to update that field value</h6>
        <table class="table table-sm border mt-2">
         
          <tr class="bg-dark text-white">
            <td>COLUMN</td>
            <td>HEADING</td>
            <td>NOTES</td>
          </tr>
          <tr>
            <td>A</td>
            <td>code</td>
            <td></td>
          </tr>
          
           <tr>
            <td>B</td>
            <td>current_cost</td>
            <td>Update cost pricing (optional)</td>
          </tr>
          <tr>
            <td>C</td>
            <td>on_hand</td>
            <td>Update current stock on hand - Stock Take (optional)</td>
          </tr>
         
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import partRepo from "@/api/repos/partRepo";
import formGroup from "@/components/common/FormGroup";
import fileUpload from "@/components/common/FileUpload";

export default {
  components: {
    formGroup,
    fileUpload
  },
  computed: {},

  data() {
    return {
      
      selectedFile:[],
      fileUploading: false,
     

      parts: {},

      errors: null,
      submitStatus: null,
      loading: false,
    };
  },



  methods: {
    

     async handleSubmit() {
      this.loading = true;
      this.submitStatus = "PENDING";
     

      if (this.fileUploading) {
        
        if (this.fileUploading) alert("file uploading...");
        this.loading = false;
        this.submitStatus = null;
      } else {

        if(this.selectedFile.length==0){
           this.loading = false;
           this.submitStatus = null;
          return alert("Please upload file");
        }

        try {
          this.parts.file_id = this.selectedFile;
        
          await partRepo.upload(this.parts);

           this.$root.$bvToast.toast("Success", {
              title: "Uploaded Successfully",
              autoHideDelay: 3000,
              variant: "success",
            });


            this.selectedFile = [];
         
        } catch (error) {
          console.log(error);
            this.$root.$bvToast.toast(error.message, {
              title: "Errors on form data",
              autoHideDelay: 3000,
              variant: "danger",
            });
          
        } finally {
          this.loading = false;
          this.submitStatus = null;
        }
      }
    },

  },


};
</script>


